function init_header() {
    // Mobile hambuger
    $('.js-toggle-mobile-menu').on('click', function() {
      var $body = $('body');
      var $hamburger = $('.js-hamburger');
  
      $body.toggleClass('mobile-menu-open');
      $hamburger.toggleClass('is-active');
    });

    var $header = $('.header');
    var $body = $('body');
    var state = 'top';

    function eval_header_shadow() {
      if($(document).scrollTop() > $header.height()) {
        if(state == 'top') {
          state = 'bottom';
          $body.addClass('scrolled');
        }
      }
      else {
        if(state == 'bottom') {
          state = 'top';
          $body.removeClass('scrolled'); 
        }
      }
    }

    eval_header_shadow();
    $(document).scroll(eval_header_shadow);
}

$(document).ready(function() {
  init_header();
});
   